export const isNumber = (text: string) => /^\d+$/.test(text)
